<ng-template [ngIf]="situacao?.canEdit">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [disabled]="disabled"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="" *ngIf="isShowNenhumaSituacao">NENHUMA SITUAÇÃO</option>
        <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome | uppercase}}</option>
    </select>  
</ng-template>

<ng-template [ngIf]="!situacao?.canEdit">
    <input type="text" class="form-control" [value]="situacao?.nome | uppercase" disabled="disabled" readonly="readonly">
</ng-template>